import useAppStore from '@shared/store/useAppStore'

/**
 * subsystemId: 子系统id， 这个是后台写死的，跟后台对应上
 * key: 子应用名称(唯一) 统一配置中影响basepath, app_basepath
 */
const list = [
  {
    key: 'admin-workflow',
    subsystemId: 2,
    subsystemName: '工单系统',
    devEntry: 'http://localhost:4002/admin-workflow/'
  },
  {
    key: 'admin-basic',
    subsystemId: 3,
    subsystemName: '城市GIS管网系统',
    devEntry: 'http://localhost:4003/admin-basic/'
  },
  {
    key: 'admin-iot',
    subsystemId: 4,
    subsystemName: '物联网中心',
    devEntry: 'http://localhost:4004/admin-iot/'
  },
  {
    key: 'admin-environment',
    subsystemId: 5,
    subsystemName: '水环境监测',
    devEntry: 'http://localhost:4005/admin-environment/'
  },
  {
    key: 'admin-pump',
    subsystemId: 6,
    subsystemName: '泵站调度',
    devEntry: 'http://localhost:4006/admin-pump/'
  },
  {
    key: 'admin-waterlogging',
    subsystemId: 7,
    subsystemName: '内涝监测指挥系统',
    devEntry: 'http://localhost:4007/admin-waterlogging/'
  },
  {
    key: 'admin-maintenance',
    subsystemId: 8,
    subsystemName: '运养中心',
    devEntry: 'http://localhost:4008/admin-maintenance/'
  },
  {
    key: 'integrated-pipeline',
    subsystemId: 9,
    subsystemName: '综合管线',
    devEntry: 'http://localhost:4009/integrated-pipeline/'
  },
  {
    key: 'admin-agriculture',
    subsystemId: 10,
    subsystemName: '农业管理',
    devEntry: 'http://localhost:4010/admin-agriculture/'
  }
]

// ------------------- 实际配置是下面这个配置可以灵活替换， 目前为了方便统一处理才配置list用name字段通用---------------------------------
// {
//   name: 'admin-basic', // 子应用名称(唯一)
//   entry: '/admin-basic/', // 子应用部署的访问路径，这里因为是在同一域名这样配置就好了
//   container: '#view-main', // 渲染子应用的容器 shared/layout/MainApp.vue
//   activeRule: (location) => {
//     // 路由中包含下面路由时，激活该微应用(统一约定/micro-app开头)
//     return location.pathname.includes('/micro-app/admin-basic')
//   },
//   props: {
//     // 注意：传给微应用的basepath，在微应用启动时会使用到(！！！重点)
//     app_basepath: import.meta.env.VITE_BASE_PATH + '/micro-app/admin-basic'
//   }

export default list.map((item) => {
  const entry = import.meta.env.MODE === 'development' ? item.devEntry : item.entry || `/${item.key}/`

  return {
    name: item.key, // 子应用名称(唯一)
    entry, // 子应用部署的访问路径，这里因为是在同一域名这样配置就好了
    container: '#view-main', // 渲染子应用的容器 shared/layout/MainApp.vue
    activeRule: (location) => {
      const appStore = useAppStore()
      // 路由中包含下面路由时，激活该微应用(统一约定/micro-app开头)
      const flag = location.pathname.includes(`/micro-app/${item.key}`)
      if (flag) {
        appStore.dynamicSystemList.set(item.subsystemName, {
          name: item.subsystemName,
          path: `/micro-app/${item.key}`
        })
        appStore.activeSystem = item.subsystemName
      }

      return flag
    },

    props: {
      // 注意：传给微应用的basepath，在微应用启动时会使用到(！！！重点)
      app_basepath: `${import.meta.env.VITE_BASE_PATH}/micro-app/${item.key}`
    }
  }
})
